var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderIconNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33366 3.33333V18.3333H16.667V20H3.33366C2.41699 20 1.66699 19.25 1.66699 18.3333V3.33333H3.33366ZM12.5003 5.83333H17.0837L12.5003 1.25V5.83333ZM6.66699 0H13.3337L18.3337 5V15C18.3337 15.925 17.592 16.6667 16.667 16.6667H6.66699C5.74199 16.6667 5.00033 15.9167 5.00033 15V1.66667C5.00033 0.741667 5.74199 0 6.66699 0ZM14.167 13.3333V11.6667H6.66699V13.3333H14.167ZM16.667 10V8.33333H6.66699V10H16.667Z",
    fill: "#C7222A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderIconNew);
export default __webpack_public_path__ + "static/media/folderIconNew.24acd8833782efa2aa58e1d0e23ee5de.svg";
export { ForwardRef as ReactComponent };